/*
 * @Descripttion:
 * @version:
 * @Author: limin
 * @Date: 2021-03-23 17:18:02
 * @LastEditors: limin
 * @LastEditTime: 2021-03-25 21:18:14
 */
import request from '../request'
const path = '';
export default {

}
